/* eslint max-len: ["error", { "code": 135, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import windowSize from 'react-window-size';
import CircularProgress from 'material-ui/CircularProgress';
import {fetchPost} from '../actions/post';
import {Utils} from './Utils';
import ErrorConnection from './ErrorConnection';
import * as postTypes from '../constants/CategoryTypes';

Utils.init('Terms');

export class Terms extends Component {
    static propTypes = {
        locale: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        privacy: PropTypes.object.isRequired,
        privacyPost: PropTypes.object,
        idPost: PropTypes.string.isRequired,
        firstFetchPrivacy: PropTypes.func.isRequired,
        windowWidth: PropTypes.number.isRequired,
    };

    componentDidMount() {
        this.props.firstFetchPrivacy(this.props.idPost);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.locale.locale !== nextProps.locale.locale) {
            this.props.firstFetchPrivacy(nextProps.idPost);
        }
    }

    render() {
        if (this.props.privacy.error) {
            return (
                <ErrorConnection/>
            );
        }

        if (this.props.privacy.isFetching || this.props.privacyPost === undefined) {
            return (
                <div className="circular-progress">
                    <CircularProgress color={this.props.theme.objectTheme.palette.accent1Color}/>
                </div>
            );
        }

        return (
            <Fragment>
                <div style={{margin: '25px'}} dangerouslySetInnerHTML={{__html: this.props.privacyPost.content.rendered}} />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.locale.locale,
    privacy: state.post,
    idPost: state.locale.locale.locale === 'it'? postTypes.TERMS_IT : postTypes.TERMS_EN,
    privacyPost: state.post.items[state.locale.locale.locale === 'it'? postTypes.TERMS_IT : postTypes.TERMS_EN],
    theme: state.theme,
});

const mapDispatchToProps = {
    firstFetchPrivacy: fetchPost,
};

export default windowSize(connect(
    mapStateToProps,
    mapDispatchToProps
)(Terms));



// WEBPACK FOOTER //
// ./src/components/Terms.js